/* =========================================================
   VELMORA — Predictive search
   Uses Shopify's native /search/suggest.json with section rendering,
   so result markup comes from Liquid rather than JS templates.
   ========================================================= */
(function () {
  "use strict";

  function debounce(fn, wait) {
    var t;
    return function () {
      clearTimeout(t);
      var args = arguments;
      var ctx = this;
      t = setTimeout(function () {
        fn.apply(ctx, args);
      }, wait);
    };
  }

  function init(input) {
    var selector = input.getAttribute("data-predictive-target");
    var panel = selector ? document.querySelector(selector) : null;
    if (!panel) return;
    var results = panel.querySelector("[data-predictive-results]");
    if (!results) return;

    var lastQuery = "";
    var controller = null;

    var run = debounce(function (query) {
      if (!query || query.length < 2) {
        results.innerHTML = "";
        return;
      }

      if (controller) controller.abort();
      controller = typeof AbortController !== "undefined" ? new AbortController() : null;

      var url =
        "/search/suggest?q=" +
        encodeURIComponent(query) +
        "&resources[type]=product,collection,page,article" +
        "&resources[limit]=6" +
        "&resources[options][unavailable_products]=last" +
        "&section_id=predictive-search";

      fetch(url, controller ? { signal: controller.signal } : undefined)
        .then(function (res) {
          if (!res.ok) throw new Error("search failed");
          return res.text();
        })
        .then(function (text) {
          if (query !== lastQuery) return;
          var parsed = document.createElement("div");
          parsed.innerHTML = text;
          var fresh = parsed.querySelector("#predictive-search");
          results.innerHTML = fresh ? fresh.innerHTML : "";
          document.dispatchEvent(new CustomEvent("velmora:content-updated"));
        })
        .catch(function () {
          /* aborted or offline — leave previous results in place */
        });
    }, 240);

    input.addEventListener("input", function () {
      lastQuery = input.value.trim();
      run(lastQuery);
    });
  }

  function initAll() {
    document.querySelectorAll("[data-predictive-input]").forEach(init);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
